export default {
    urlShareHistory: state => state.urlShareHistory,
}
